module.exports = __webpack_public_path__ + "img/progress_report_educational_services.23cd815f.svg";